import { PrematchPageRowElement, } from "..";

export function createEventRows(
    events: Array<any>,
    rowCount: number,
    shouldGroupByTournament: Boolean = false,
) {
    if (shouldGroupByTournament) {
        return groupByTournaments(events, rowCount);
    }
    return groupBySport(events, rowCount);
}

function groupByTournaments(
    events: Array<any>,
    rowCount: number,
) {
    // current page reference
    let pd: PrematchPageRowElement[] = [];

    // all pages
    const pages: PrematchPageRowElement[][] = [pd];

    let lastSportId: string;
    let lastCategoryId: string;
    let lastTournamentId: string;
    let lastIsOutright: boolean = false;

    let currentPagePlacesTaken: number = 0;

    events.forEach(event => {
        if (!event) {
            return;
        }

        const {
            sportCategoryId,
            tournamentId,
            numberOfRows,
            isOutright,
            sportId,
            id,
        } = event;

        const eventNumberOfRows = isNaN(numberOfRows) ? 1 : numberOfRows;
        if (sportId !== lastSportId ||
            sportCategoryId !== lastCategoryId ||
            tournamentId !== lastTournamentId ||
            isOutright !== lastIsOutright
        ) {
            if (currentPagePlacesTaken + eventNumberOfRows + 1 > rowCount) {
                pd = [];
                currentPagePlacesTaken = 0;
                pages.push(pd);
            }

            lastIsOutright = isOutright;
            lastSportId = sportId;
            lastCategoryId = sportCategoryId;
            lastTournamentId = tournamentId;

            pd.push(PrematchPageRowElement.create(sportId, 'header', 1, sportCategoryId, tournamentId, isOutright));
            ++currentPagePlacesTaken;
        }
        else if (currentPagePlacesTaken + eventNumberOfRows > rowCount) {
            pd = [];
            pages.push(pd);
            pd.push(PrematchPageRowElement.create(sportId, 'header', 1, sportCategoryId, tournamentId, isOutright));
            currentPagePlacesTaken = 1;
        }

        pd.push(PrematchPageRowElement.create(id, 'event', undefined, undefined, undefined, isOutright));
        currentPagePlacesTaken += eventNumberOfRows;
    });

    return pages;
}

function groupBySport(
    events: Array<any>,
    rowCount: number,
) {
    let pd: PrematchPageRowElement[] = [];
    const pages = [pd];
    let lastSportId: string;

    // tracks number of places taken for the current page
    // this is required because events can take up multiple rows
    let currentPagePlacesTaken: number = 0;


    events.forEach(event => {
        if (!event) {
            return;
        }

        const {
            sportCategoryId,
            tournamentId,
            numberOfRows,
            sportId,
            id,
        } = event;

        const eventNumberOfRows = isNaN(numberOfRows) ? 1 : numberOfRows;
        if (lastSportId !== sportId) {
            if (currentPagePlacesTaken + eventNumberOfRows + 1 > rowCount) {
                pd = [];
                currentPagePlacesTaken = 0;
                pages.push(pd);
            }
            // push header first
            pd.push(PrematchPageRowElement.create(sportId, 'header', 1, sportCategoryId, tournamentId, false));
            ++currentPagePlacesTaken;
            lastSportId = sportId;
        } else if (currentPagePlacesTaken + eventNumberOfRows > rowCount) {
            pd = [];
            pages.push(pd);
            pd.push(PrematchPageRowElement.create(sportId, 'header', 1, sportCategoryId, tournamentId, false));
            currentPagePlacesTaken = 1;
        }

        pd.push(PrematchPageRowElement.create(id, 'event', eventNumberOfRows));
        currentPagePlacesTaken += eventNumberOfRows;
    });

    return pages;
}